/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { TypeLatLng } from './TypeLatLng';
import {
    TypeLatLngFromJSON,
    TypeLatLngFromJSONTyped,
    TypeLatLngToJSON,
} from './TypeLatLng';
import type { UserLocationPlaceType } from './UserLocationPlaceType';
import {
    UserLocationPlaceTypeFromJSON,
    UserLocationPlaceTypeFromJSONTyped,
    UserLocationPlaceTypeToJSON,
} from './UserLocationPlaceType';

/**
 * 
 * @export
 * @interface V1CreateUserLocationRequest
 */
export interface V1CreateUserLocationRequest {
    /**
     * 
     * @type {TypeLatLng}
     * @memberof V1CreateUserLocationRequest
     */
    point: TypeLatLng;
    /**
     * 
     * @type {UserLocationPlaceType}
     * @memberof V1CreateUserLocationRequest
     */
    place: UserLocationPlaceType;
}

/**
 * Check if a given object implements the V1CreateUserLocationRequest interface.
 */
export function instanceOfV1CreateUserLocationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "point" in value;
    isInstance = isInstance && "place" in value;

    return isInstance;
}

export function V1CreateUserLocationRequestFromJSON(json: any): V1CreateUserLocationRequest {
    return V1CreateUserLocationRequestFromJSONTyped(json, false);
}

export function V1CreateUserLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1CreateUserLocationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'point': TypeLatLngFromJSON(json['point']),
        'place': UserLocationPlaceTypeFromJSON(json['place']),
    };
}

export function V1CreateUserLocationRequestToJSON(value?: V1CreateUserLocationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'point': TypeLatLngToJSON(value.point),
        'place': UserLocationPlaceTypeToJSON(value.place),
    };
}

